export enum BusinessBaseStatisticsTab {
  MostSearched = 'most_searched',
  MostRequested = 'most_requested',
}
